module.exports = __webpack_public_path__ + "img/power_treads_agi_colorblind.e8d7a98d.png";